import { http } from '~/lib/http'
import { FormType } from '~/schemas/postSchema'
import { cookieAuth } from '~/types/auth'
import { ResBlog, ResBlogById, ResBlogBySlug, ResBlogsByCategory } from '~/types/blog'
import { Res } from '~/types/common'

type BlogParam = {
    nameTag?: string
    page?: number
    limit?: number
}

type GetBlogsAllParam = {
    nameTag?: string
    limit?: number
}

const blogApi = {
    getBlogs: async ({ nameTag, page = 1, limit = 20 }: BlogParam = {}) => {
        const query = new URLSearchParams()
        if (nameTag) {
            query.set('tag', nameTag)
        }
        query.set('page', `${Math.max(1, page)}`)
        query.set('limit', `${Math.min(100, Math.max(1, limit))}`)
        return (await http.get<Res<ResBlog[]>>(`/blogs?${query.toString()}`)).data
    },
    getBlogsAll: async ({ nameTag, limit = 100 }: GetBlogsAllParam = {}) => {
        const allBlogs: ResBlog[] = []
        let page = 1
        const safeLimit = Math.min(100, Math.max(1, limit))

        while (true) {
            const blogs = await blogApi.getBlogs({
                nameTag,
                page,
                limit: safeLimit
            })
            allBlogs.push(...blogs)
            if (blogs.length < safeLimit) {
                break
            }
            page += 1
        }

        return allBlogs
    },
    getBlogsByCategory: async (slug: string) => {
        return (await http.get<Res<ResBlogsByCategory>>(`/blogs/category/${slug}`)).data
    },
    getBlog: async (slug: string) => {
        return (await http.get<Res<ResBlogBySlug>>(`/blogs/${slug}`, {})).data
    },
    getAll: async (token?: string) => {
        return await http.get<Res<ResBlog[]>>('/manager/blogs', {
            headers: token
                ? {
                      Cookie: `${cookieAuth}=${token}`
                  }
                : {}
        })
    },
    getBlogById: async (id: string, token?: string) => {
        return await http.get<Res<ResBlogById>>(`/manager/blogs/${id}`, {
            headers: token
                ? {
                      Cookie: `${cookieAuth}=${token}`
                  }
                : {}
        })
    },
    createBlog: async (data: FormType) => {
        return await http.post<Res<ResBlogById>>('/manager/blogs', data, {})
    },
    updateBlog: async (id: string, data: FormType) => {
        return await http.put<Res<ResBlogById>>(`/manager/blogs/${id}`, data)
    }
}

export default blogApi
